import { render } from "./Playable.vue?vue&type=template&id=56b5c4b1"
import script from "./Playable.vue?vue&type=script&lang=js"
export * from "./Playable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__